module.exports = __webpack_public_path__ + "static/media/howToPlay3.077b7602.png";